import { Phone, MessageCircle, Shield, EyeOff } from "lucide-react";
import { IMAGES } from "./constants";
import { useI18n } from "../../i18n";

const PrivacySection = () => {
  const { t } = useI18n();
  const cards = [
    { icon: Phone, title: t("privacy.calls_title"), text: t("privacy.calls_text") },
    { icon: MessageCircle, title: t("privacy.msgs_title"), text: t("privacy.msgs_text") },
    { icon: Shield, title: t("privacy.total_title"), text: t("privacy.total_text") },
  ];

  return (
    <section className="relative overflow-hidden bg-[#0B2545] py-20 md:py-28" data-testid="privacy-section">
      <div
        className="pointer-events-none absolute -left-32 top-10 h-96 w-96 rounded-full opacity-30 blur-3xl"
        style={{ background: "radial-gradient(circle, #1B84FF 0%, rgba(11,37,69,0) 70%)" }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <div>
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#5BC0FF]/30 bg-[#5BC0FF]/10 px-4 py-2 text-sm font-medium text-[#9FD8FF]">
              <EyeOff className="h-4 w-4" />
              {t("privacy.badge")}
            </div>
            <h2 className="mb-6 text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
              {t("privacy.title")}
            </h2>
            <p className="mb-10 max-w-xl text-base text-slate-300 md:text-lg">{t("privacy.subtitle")}</p>

            <div className="grid gap-5 sm:grid-cols-3">
              {cards.map((c, i) => (
                <div
                  key={i}
                  className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm transition-colors hover:bg-white/10"
                  data-testid={`privacy-card-${i}`}
                >
                  <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-[#1B84FF]/20">
                    <c.icon className="h-5 w-5 text-[#5BC0FF]" />
                  </span>
                  <h3 className="mb-1 font-semibold text-white">{c.title}</h3>
                  <p className="text-sm text-slate-300">{c.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="overflow-hidden rounded-3xl border border-white/10 shadow-[0_30px_70px_rgba(0,0,0,0.35)]">
              <img
                src={IMAGES.carRear2}
                alt="Auto con sticker QR AvisoCar"
                className="w-full"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacySection;
